module.exports = __webpack_public_path__ + "img/decor_paper.0470042e.png";